import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-48e38836"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "favorites-wrapper"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_FavoriteList = _resolveComponent("FavoriteList");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_FavoriteList, {
    items: $setup.favorites,
    check: $data.isAllLoading,
    onAddToFavorite: _cache[0] || (_cache[0] = item => $options.check(item)),
    onAddToCart: _cache[1] || (_cache[1] = item => $setup.onClickAddPlus(item)),
    onLoadMoreFavorites: _cache[2] || (_cache[2] = $event => $options.onLoadMoreFavorites())
  }, null, 8, ["items", "check"])]);
}